import { UserRole } from '@avanzu/types';

export const getRoleColor = (role: UserRole) => {
  switch (role) {
    case UserRole.OWNER:
      return 'error'; // Red
    case UserRole.ADMIN:
      return 'warning';
    case UserRole.MEMBER:
      return 'info'; // Green
    case UserRole.VIEWER:
      return 'success'; // Blue
    default:
      return 'default';
  }
};

export default getRoleColor;
